<template>
    <div  class=" bg-round bg-fff">
        <div class="container">
            <Bread class="ma-t-30" />
        </div>
       
        <div class="container line-height-35 main-md vhtml ma-t-40" id="app">
            <div v-html="detail.Content"></div>
        </div>

        <div  class="img-a-bg" v-if="detail.Content">
            <img src="../../img/merge/i2.png" alt="" srcset="" class="img-logo c-pointer">
        </div>
        
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";
    .about-text {
        line-height: 30px;
    }

    .img-a-bg {
        width: 100%;
        height: 285px;
        background: url('../../img/merge/a1.png') no-repeat;
        background-size: cover;
        background-position: center center;
        text-align: right;
        line-height: 285px;
    }

    .img-logo {
        width: 206px;
        height: 206px;
        margin-right: 40px;
    }

    .img-person {
        width: 220px;
    }

    @media (min-width: 768px) {
        .main-md {
            padding-left: 181px;
            padding-right: 210px;
        }
    }
    .video{
        width: 100%;
    }
    
    @media (max-width:768px) {
        .img-a-bg{
            display:none;
        }
    }
</style>
<script>
    import {getOther} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                footbottom:123,
                detail:"",
                Content:"",
            };
        },
        created() {
            console.log("开始开发");
            this.getDetail();
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            //获取数据
            getDetail() {
                let data = {
                    code: "aboutus.shisw",
                };
                getOther(data).then((res) => {
                    console.log(res);
                    this.detail = res.data.Data;
                    // this.Content=res.data.Data.Content.replace(/<img/g,"<img mode='widthFix' style='width: 100%;vertical-align: middle;height: auto;'");
                });
            },
            toPage(url){
                this.$router.push("/merge/"+url);
            }
        },
    };
</script>
